import React, { useState } from "react";
import { Modal, Button, Image } from "react-bootstrap";
import { deleteReferralreq } from "../../../../store/actions/SuperAdminActions/SuperAdminReferralCashbackAction";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";

const SuperAdminDeleteReferral = (props) => {
  const [showDeleteOffer, seShowDeleteOffer] = useState(false);
  const history = useHistory();
  const onSuccessDeleteref = () => {
    seShowDeleteOffer(false);
    if (props.onClickCloseView) {
      props.onClickCloseView();
      history.push("/SuperAdminReferralRewarddashboard");
    }
  };
  const onErrorDeleteref = () => {
    seShowDeleteOffer(false);
  };
  const handleCloseDeleteOffer = () => {
    const token = props.auth.user.accessToken;
    props.deleteReferralreq(
      props.refId,
      token,
      onSuccessDeleteref,
      onErrorDeleteref
    );
  };

  const onDeleteNo = () => {
    seShowDeleteOffer(false);
  };

  const handleShowDeleteOffer = () => {
    seShowDeleteOffer(true);
  };
  return (
    <React.Fragment>
      <Button
        variant="link"
        className="enIconBtn mr-3"
        onClick={handleShowDeleteOffer}
      >
        <Image
          src={require("../../../../assets/images/UserManagement/Delete.svg")}
          alt="Delete offer"
          title="Delete offer"
          fluid
        />
      </Button>
      <Modal show={showDeleteOffer} onHide={onDeleteNo} centered>
        <Modal.Header className="py-0 pt-2 border-0" closeButton>
          <Modal.Title></Modal.Title>
        </Modal.Header>
        <Modal.Body className="f16-500">
          Are you sure to Delete the referral ?
        </Modal.Body>
        <Modal.Footer className="justify-content-start border-0">
          <Button
            variant="outline-secondary"
            className="btn-lg mr-4 px-5"
            onClick={onDeleteNo}
          >
            No
          </Button>
          <Button
            variant="danger"
            className="btn-lg px-5"
            onClick={handleCloseDeleteOffer}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};

SuperAdminDeleteReferral.propTypes = {
  auth: PropTypes.object.isRequired,
  deleteReferralreq: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
});

export default connect(mapStateToProps, { deleteReferralreq })(
  SuperAdminDeleteReferral
);
